import { all } from 'redux-saga/effects';
import user from './user_saga';
import watchOrderTransactionHistory from './order_transaction_history_saga';
import watchOrderHistory from './order_history_saga';
import watchTransaction from './transaction_saga';
import watchInit from './init_saga';
import watchAllSettingFeeTransaction from './setting_fee_transaction_saga';
import watchAllTransactionFee from './transaction_fee_saga';
import watchAllUsers from './login_saga';
import watchAdmins from './admin_saga';
import watchTools from './tools_saga';
import watchSettings from './setting_saga';
import watchStatistic from './statistic_saga';
import watchAuthorization from './authorization_saga';
import watchAffiliate from './affiliate_saga';
import watchAdminWallet from './admin_wallet_balance_saga';
import watchCampaign from './campaign_saga';
import watchNotification from './notification_saga';
import watchCommission from './commission_saga';
import watchPrizes from './prize_saga';
import watchFavorite from './favorite_saga';

function* rootSaga() {
  yield all([
    user(),
    watchOrderTransactionHistory(),
    watchOrderHistory(),
    watchTransaction(),
    watchInit(),
    watchAllSettingFeeTransaction(),
    watchAllTransactionFee(),
    watchAllUsers(),
    watchAdmins(),
    watchTools(),
    watchSettings(),
    watchStatistic(),
    watchAuthorization(),
    watchAffiliate(),
    watchAdminWallet(),
    watchCampaign(),
    watchNotification(),
    watchCommission(),
    watchPrizes(),
    watchFavorite(),
  ]);
}

export default rootSaga;
